import { render, staticRenderFns } from "./PromotionalFreeSpins.vue?vue&type=template&id=668fa1b8&scoped=true&"
import script from "./PromotionalFreeSpins.vue?vue&type=script&lang=ts&"
export * from "./PromotionalFreeSpins.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionalFreeSpins.vue?vue&type=style&index=0&id=668fa1b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668fa1b8",
  null
  
)

export default component.exports